import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'quotation';

const DatabaseService = {
 getPagedResult({
      page,limit,searchText,searchBy
  }) {
    return Http.get(`/${RESOURCE_NAME}?page=${page}&limit=${limit}&searchText=${searchText}&searchBy=${searchBy}`);
  },
  updateStatus(form) {
    return Http.post(`/invoice/status`, form);
  },
};

export default DatabaseService;
